import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { SEO } from '../components/SEO';
import { buildBreadcrumbList } from '../lib/structuredData';
import { ArrowLeftIcon, MousePointerClickIcon, PieChartIcon, TrendingUpIcon } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
export const TeamLid4Page: React.FC = () => {
  const navigate = useNavigate();
  return <div className="min-h-screen bg-white font-sans text-[#111827]" data-id="element-2766" data-mp="1til19l6inm8">
      <SEO title="Norden, Ads & Data Specialist | Noord Digital" description="Maak kennis met Norden, Ads & Data Specialist bij Noord Digital. Expert in Google Ads, data-analyse en conversie optimalisatie voor B2B bedrijven." keywords="norden noord digital, ads specialist, data specialist, google ads expert, conversie optimalisatie, b2b marketing" canonical="https://noorddigital.nl/over-ons/norden" jsonLd={buildBreadcrumbList([{
      name: 'Over ons',
      path: '/over-ons'
    }, {
      name: 'Norden',
      path: '/over-ons/norden'
    }])} data-id="element-2767" data-mp="6tn6zf4uwaju" />
      <Header data-id="element-2768" data-mp="2syl5o8tgl9k0" />

      <main className="pt-32 pb-20 lg:pt-40 lg:pb-24" data-id="element-2769" data-mp="2o1l2c5nzukwl">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2770" data-mp="2o11ujhs25cwa">
          <button onClick={() => navigate('/over-ons')} className="inline-flex items-center gap-2 text-[#004AC7] font-medium hover:underline mb-12" data-id="element-2771" data-mp="32r0of8cky25y">
            <ArrowLeftIcon className="w-4 h-4" data-id="element-2772" data-mp="2xs6607iiyfmd" /> Terug naar het team
          </button>

          <div className="flex flex-col lg:flex-row gap-16 items-start" data-id="element-2773" data-mp="2a2bupudusz48">
            <div className="lg:w-1/3 flex justify-center lg:justify-start" data-id="element-2774" data-mp="253sapzitlxei">
              <div className="w-[300px] h-[300px] rounded-full border-4 border-[#004AC7] bg-[#EEF5FA] flex items-center justify-center shadow-lg overflow-hidden" data-id="element-2775" data-mp="2k0izleuvbqpv">
                <img src="https://cdn.magicpatterns.com/uploads/fv5nFyNt1SPvWUkxd2YKYJ/Norden_portret_300dpi_2.png" alt="Norden" className="w-full h-full object-cover" data-id="element-2776" data-mp="2f2zogntgvu25" />
              </div>
            </div>

            <div className="lg:w-2/3" data-id="element-2777" data-mp="3qieh5fen7zrg">
              <h1 className="text-4xl md:text-5xl font-bold text-[#111827] mb-2" data-id="element-2778" data-mp="1enhh966vk4j">
                Norden
              </h1>
              <p className="text-xl text-[#607697] font-medium mb-8" data-id="element-2779" data-mp="6bnszzlt5f31">
                Ads & Data Specialist
              </p>

              <div className="prose prose-lg text-[#4B5563] mb-12" data-id="element-2780" data-mp="b9yxdutc2xdv">
                <p className="mb-4" data-id="element-2781" data-mp="g9tsybo20b59">
                  Als Ads & Data Specialist zorg ik ervoor dat elke
                  geïnvesteerde euro in advertenties maximaal rendement
                  oplevert. Ik beheer de Google Ads-campagnes binnen de
                  CorePrint methode en stuur scherp op data en conversies.
                </p>
                <p className="mb-4" data-id="element-2782" data-mp="3thoebrd84b2b">
                  Ik geloof niet in 'set and forget'. Campagnes vereisen
                  continue monitoring, A/B-testen en optimalisatie. Door data
                  nauwkeurig te analyseren, ontdek ik patronen en kansen die
                  anderen over het hoofd zien.
                </p>
                <p data-id="element-2783" data-mp="1i6j1dxu860gd">
                  Mijn aanpak is altijd resultaatgericht. Of het nu gaat om het
                  verlagen van de kosten per lead (CPA) of het verhogen van de
                  Return on Ad Spend (ROAS), ik zorg dat de cijfers kloppen en
                  de doelstellingen worden behaald.
                </p>
              </div>

              <h2 className="text-2xl font-bold text-[#111827] mb-6" data-id="element-2784" data-mp="148klup463xza">
                Expertise
              </h2>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12" data-id="element-2785" data-mp="ugomzbu9c3u0">
                <div className="bg-[#F7F8FA] p-6 rounded-xl border border-gray-100" data-id="element-2786" data-mp="uek9q3agxsh2">
                  <MousePointerClickIcon className="w-8 h-8 text-[#004AC7] mb-4" data-id="element-2787" data-mp="qfl5kkwk9zqo" />
                  <h3 className="font-bold text-[#111827]" data-id="element-2788" data-mp="lh9y2gtqo1bm">Google Ads</h3>
                </div>
                <div className="bg-[#F7F8FA] p-6 rounded-xl border border-gray-100" data-id="element-2789" data-mp="gfud0ork9ut8">
                  <PieChartIcon className="w-8 h-8 text-[#004AC7] mb-4" data-id="element-2790" data-mp="bhj4chd05qcl" />
                  <h3 className="font-bold text-[#111827]" data-id="element-2791" data-mp="2bk28m4s0mm71">Data-analyse</h3>
                </div>
                <div className="bg-[#F7F8FA] p-6 rounded-xl border border-gray-100" data-id="element-2792" data-mp="2gj58zbx1w48o">
                  <TrendingUpIcon className="w-8 h-8 text-[#004AC7] mb-4" data-id="element-2793" data-mp="2gkzk5yiishzk" />
                  <h3 className="font-bold text-[#111827]" data-id="element-2794" data-mp="21tz1z1rz19q8">
                    Conversion Optimalisatie
                  </h3>
                </div>
              </div>

              <a href="/#contact" className="inline-block bg-[#004AC7] text-white px-8 py-4 rounded-lg font-bold hover:bg-[#003A9E] transition-colors shadow-md" data-id="element-2795" data-mp="1ssj3nsefky2d">
                Neem contact op met Norden
              </a>
            </div>
          </div>
        </div>
      </main>

      <Footer data-id="element-2796" data-mp="1nty0pl7so0a8" />
    </div>;
};